import React, { useEffect, useRef, useState } from "react";
import SidebarSolicitante from "../../components/sidebar_solicitante/Sidebar_Solicitante";
import { useHistory, useLocation } from "react-router-dom";
import Axios from "axios";
import parse from "html-react-parser";
import { formatDate } from "../../utils/date";

function DetalhesConsultoria() {
  let history = useHistory();
  const location = useLocation();
  const [textSolicitado, setTextSolicitado] = useState("");
  const [textFarma, setTextFarma] = useState("");
  const [solicitante, setSolicitante] = useState("");
  const [farmaceutico, setFarmaceutico] = useState("");
  const [data, setData] = useState("");
  const [area, setArea] = useState("");
  const [status, setStatus] = useState("");

  const [id, setId] = useState(location.state.detail);

  useEffect(() => {
    carregaDados();
  }, []);

  const carregaDados = () => {
    Axios.defaults.withCredentials = false;
    Axios.post(`${process.env.REACT_APP_API_BASE_URL}/buscarTelec`, {
      protocolo: id,
    }).then((response) => {
      if (response.data.message) {
        alert(response.data.message);
      } else {
        setTextSolicitado(response.data[0].assunto);
        if (response.data[0].resposta == null) {
          setTextFarma("");
        } else {
          setTextFarma(response.data[0].resposta);
        }
        setData(response.data[0].data_hora);
        setArea(response.data[0].area_interesse);
        setFarmaceutico(response.data[0].nome_farmaceutico);
        setSolicitante(response.data[0].nome);
        setStatus(response.data[0].status);
      }
    });
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <SidebarSolicitante>
        <p style={{ paddingTop: "1%", paddingBottom: "3%" }}>
          Detalhes de solicitação
        </p>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            height: "20%",
            overflowY: "scroll",
          }}
        >
          {parse(textSolicitado)}
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            paddingTop: "30px",
            alignItems: "flex-end",
          }}
        >
          <p style={{ marginLeft: "5%" }}>
            Área: <b>{area}</b>
          </p>
          <p style={{ marginLeft: "5%" }}>
            Status: <b>{status}</b>
          </p>
          <p style={{ marginLeft: "5%" }}>
            Data: <b>{formatDate(data)}</b>
          </p>
        </div>
        <h1
          className="titulo"
          style={{ paddingTop: "0.5%", paddingBottom: "1%" }}
        >
          Resposta farmacêutico
        </h1>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            height: "20%",
            overflowY: "scroll",
          }}
        >
          {parse(textFarma)}
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            paddingTop: "30px",
            alignItems: "flex-end",
          }}
        >
          <p style={{}}>
            Farmacêutico: <b>{farmaceutico}</b>
          </p>
        </div>
        {/*                
                <table class="content-table">
                    <thead>
                        <tr>
                        <th>Arquivo</th>
                        <th>Quem enviou</th>
                        <th>Tipo</th>
                        </tr>
                    </thead>
                    <tbody align="justify">
                        <tr>
                            <th></th>
                            <th></th>
                        </tr>
                    </tbody>
                </table>
            */}
      </SidebarSolicitante>
    </div>
  );
}

export default DetalhesConsultoria;
